import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { ReactElement, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { businessIntroQuery } from '@/__generated__/businessIntroQuery.graphql';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { SurveyIntroContainer } from '@/components/survey/intro/SurveyIntroContainer';
import { introQuery } from '@/graphql/query/survey/business';
import { currentBusinessBmanTinAtom, refundHistoryIdAtom } from '@/lib/stores/survey/common';

function SurveyBusinessIntroPage() {
  const refundHistoryId = useAtomValue(refundHistoryIdAtom);
  const bmanTin = useAtomValue(currentBusinessBmanTinAtom);
  const [queryRef, loadQuery] = useQueryLoader<businessIntroQuery>(introQuery);
  const eventAttributes = useSurveyUserEventAttributes();

  useEffect(() => {
    if (refundHistoryId && bmanTin) {
      loadQuery({ refundHistoryId, bmanTin }, { fetchPolicy: 'network-only' });
    }
  }, [loadQuery, refundHistoryId, bmanTin]);

  if (!queryRef) return <></>;
  return (
    <PageViewEventLogger pageName={'survey_intro'} eventProperty={eventAttributes}>
      <SurveyIntroContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

SurveyBusinessIntroPage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>{page}</BusinessProvider>
  </SurveyProvider>
);

export default SurveyBusinessIntroPage;
